module.exports = __webpack_public_path__ + "static/img/logo2x.8414dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2x.png
// module id = lVbX
// module chunks = 1